// Medication reminder types
export const INTERVAL_FREQUENCY_OPTION = '678e377becaf026d09867fdf'
export const SEVERAL_TIMES_DAY_FREQUENCY_OPTION = '678e389becaf026d09867fe0'
export const WEEK_DAYS_FREQUENCY_OPTION = '678e38b7ecaf026d09867fe1'
export const CYCLIC_FREQUENCY_OPTION = '678e38d8ecaf026d09867fe2'
// Interval time options
export const HOURS_INTERVAL_OPTION = 0
export const DAYS_INTERVAL_OPTION = 1


// WEBPACK FOOTER //
// ./src/constants/medicationReminder.js